module.exports = __webpack_public_path__ + "img/bespoke123_09.f304a42c.jpg";